import React, { ReactNode, useEffect } from 'react';

import Footer from '../components/Footer';
import ProLayout from '@ant-design/pro-layout';
import { UserOutlined } from '@ant-design/icons';
import RightContent from '../components/RightContent';

// Navigation
import { Link, useLocation } from 'react-router-dom';

// Utils
import getMenuItems from './getMenuItems';
import { useAppSelector } from '../../../store/store';
import { useWindowSize } from '../../../utils/useWindowSize';

// Constants
import { PAGE_TITLE } from '../../../constants/page';
import logo from '../../../assets/images/logo_gba.svg';
import { PRIMARY_COLOR } from '../../../constants/colors';

// Interfaces
import type { IUser } from '../../../interfaces/user';

interface LayoutProps {
  children: ReactNode;
  isWhiteLayout?: boolean;
}

const contentStyle = { margin: 0, padding: 0 } as const;

export const Layout: React.FC<LayoutProps> = (props) => {
  const { width } = useWindowSize();

  const location = useLocation();
  const isMobile = width && width <= 767;

  const user = useAppSelector((state) => state.auth.user) as IUser;

  const routes = getMenuItems(isMobile as boolean, user);

  useEffect(() => {
    setTimeout(() => {
      document.title = PAGE_TITLE;
    }, 1);
  }, []);

  return (
    <ProLayout
      layout="mix"
      logo={
        <div style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
          <div>
            <img style={{ height: 18 }} src={logo} alt="logo" />
          </div>
        </div>
      }
      fixSiderbar
      // @ts-ignore
      title={' '}
      route={routes}
      location={location}
      contentStyle={contentStyle}
      style={{ height: '100vh' }}
      footerRender={() => <Footer />}
      collapsed={!isMobile ? true : undefined}
      className={props.isWhiteLayout ? 'white-layout' : ''}
      collapsedButtonRender={!isMobile ? () => null : undefined}
      menuItemRender={(data, dom) => {
        // @ts-ignore
        return data.href ? (
          <a target="_blank" href={data.href} rel="noreferrer">
            {dom}
          </a>
        ) : data.path ? (
          <Link target={data.target} to={data.path}>
            {dom}
          </Link>
        ) : (
          dom
        );
      }}
      avatarProps={{
        size: 'small',
        icon: <UserOutlined />,
        style: { backgroundColor: PRIMARY_COLOR },
        title: isMobile ? undefined : `${user.nombre}`,
        render: (props, dom) => {
          return <RightContent dom={dom} />;
        }
      }}
      token={{
        sider: {
          colorMenuBackground: 'white'
        }
      }}
    >
      <div style={{ minHeight: `calc(100vh - 160px)` }}>{props.children}</div>
    </ProLayout>
  );
};

export default Layout;
